import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {identityProviderByIdUrl} from "../../constants/api/endpoints";
import {backendBaseUrl} from "../../constants/api/backendBaseUrl";
import {jsonToJwt} from "../../lib/jwt/jsonToJwt";
import {useAxios} from "../../hooks/axios/useAxios";

export const useQueryIdentityProvider = ({id}: { id: string }) => {
  const axiosSoft = useAxios();
  const getIdentityProvider = async () => {
    if (id) {
      const response = await axios.get(`${backendBaseUrl}${identityProviderByIdUrl(id)}`, {
        headers: {
          "Authorization": "Bearer " + jsonToJwt({}),
        }
      });
      return response.data.request_url;
    }
    return {};
  };

  const getIdentityProviderSoft = async () => {
    if (id) {
      const response = await axiosSoft.get(identityProviderByIdUrl(id));
      return response.data.request_url;
    }
    return {};
  };

  return useQuery({
    queryKey: ['identity_provider', id],
    queryFn: localStorage.getItem('refresh') ? getIdentityProviderSoft : getIdentityProvider,
  });
};